export default __webpack_public_path__ + "static/media/a15.8af2a2c1.webp";